import React, { useState } from "react";
import "./myAccount.css";
import Profile from "../../../components/MyAccount";
import { Link, useNavigate } from "react-router-dom";
import FieldExecutiveLayout from "../../../components/layouts/FieldExecutiveLayout";
import { toast } from "react-toastify";
import {
  validateAccountFormData,
  validateChangePasswordFormData,
} from "../../../utils/utils";
import useAuth from "../../../hooks/useAuth";
import MyAccountService from "../../../services/API/MyAccountManager";
import { localStorageKeys } from "../../../constant/keys";
import AuthServices from "../../../services/authServices";
import { useQuery } from "react-query";

export default function MyAccountFeildExecutive() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [passwordFormData, setPasswordFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const handleChangePassword = (e) => {
    const { value, name } = e.target;
    setPasswordFormData({ ...passwordFormData, [name]: value.trim() });
  };
  const [loading, setLoading] = useState("profile");
  const handleSubmitChangePassword = async () => {
    const error = validateChangePasswordFormData(passwordFormData);
    if (error) {
      toast.error(error);
    } else {
      try {
        const res = await MyAccountService.changePasswordService({
          userId: auth?.userId,
          ...passwordFormData,
        });
        if (res?.status_code === 200) {
          toast.success("Password updated. Login with your new password.");
          setPasswordFormData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          const response = await AuthServices.logout({type: 'change-password'});
          if (response) {
            localStorage.removeItem(localStorageKeys.aparajithaData);
            auth.setIsAuthenticated(false);
            navigate("/admin/login");
          }
        }
      } catch (error) {
        toast.error(error.message);
        setPasswordFormData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      }
    }
  };

  // Edit Details
  const localStore = JSON.parse(localStorage.getItem("aparajithaData"));
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    whatsapp_status: "",
    user_mob: "",
    user_email: "",
  });

  const { refetch } = useQuery(
    [`api/user_details`, { user_id: auth?.userId }],
    MyAccountService.getUserDetails,
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      onSuccess: async(resp) => {
        const data = resp?.data;
        const newData = {
          ...JSON.parse(localStorage.getItem("aparajithaData")),
          data: data,
          user_mob: data?.mask_mobile,
          user_email: data?.mask_email,
        };
        localStorage.setItem("aparajithaData", JSON.stringify(newData));
        const jwtValue = JSON.parse(localStorage.getItem("aparajithaData")).data;
        auth?.setEmail(jwtValue?.email);
        auth?.setPhone(jwtValue?.mobile_no);
        auth?.setName(jwtValue?.name);
        setFormData({
          fullName: jwtValue?.name,
          email: jwtValue?.email,
          phone: jwtValue?.mobile_no ? jwtValue?.mobile_no.replace("+91", "") : "",
          whatsapp_status: jwtValue?.whatsapp_status,
          user_mob: jwtValue?.mask_mobile,
          user_email: jwtValue?.mask_email,
        });
        setLoading("");
      },
    }
  );

  const handleChangeDetails = (e) => {
    const { value, name } = e.target;

    setFormData({
      ...formData,
      [name]:
        name === "phone"
          ? value.replace(/\D/g, "").trim()
          : name === "email"
          ? value.trim()
          : value,
    });
  };

  const handleCancel = () => {
    setFormData({
      fullName: auth?.name,
      email: auth?.email,
      phone: auth?.phone ? auth?.phone.replace("+91", "") : "",
      whatsapp_status: localStore?.data?.whatsapp_status,
      user_mob: localStore?.user_mob || "",
      user_email: localStore?.user_email || "",
    });
    setIsEdit(false);
  };

  const handleSubmit = async () => {
    if (isEdit) {
      const error = validateAccountFormData(formData);
      if (error) {
        toast.error(error);
      } else {
        try {
          const res = await MyAccountService.updateDetailsMyAccount({
            userId: auth?.userId,
            ...formData,
          });
          if (res?.status_code === 200) {
            const jwtValue = res?.data;
            auth?.setRoleId(jwtValue?.user_role_id);
            auth?.setName(jwtValue?.name);
            auth?.setUserId(jwtValue?.id);
            auth?.setEmail(jwtValue?.email);
            auth?.setPhone(jwtValue?.mobile_no);
            const newData = {
              ...JSON.parse(localStorage.getItem("aparajithaData")),
              data: res.data,
              user_email: res?.user_email,
              user_mob: res?.user_mob,
            };
            toast.success("Your account details updated successfully");
            setIsEdit(false);
            localStorage.setItem("aparajithaData", JSON.stringify(newData));
            setFormData({
              ...formData,
              user_mob: res?.user_mob || "",
              user_email: res?.user_email || "",
            });
          }
        } catch (error) {
          toast.error(error.message);
        }
      }
    } else {
      setIsEdit(true);
    }
  };
  return (
    <FieldExecutiveLayout>
      <div id="main" role="main">
        <div id="content">
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                <Link to={"/field-executive/dashboard"}>Home</Link>
              </li>
              <li className="breadcrumb-item active">My Account</li>
            </ol>
          </div>
          {loading !== "profile" ? (
            <Profile
              auth={auth}
              passwordFormData={passwordFormData}
              handleChangePassword={handleChangePassword}
              handleSubmitChangePassword={handleSubmitChangePassword}
              // edit Details
              handleChangeDetails={handleChangeDetails}
              handleSubmit={handleSubmit}
              isEdit={isEdit}
              formData={formData}
              handleCancel={handleCancel}
              refetch={refetch}
            />
          ) : (
            <div className="text-center">Loading...</div>
          )}
        </div>
      </div>
    </FieldExecutiveLayout>
  );
}
